import {
  reqBzdyList,
  reqQccyList,
  reqHzjyList,
  reqNyshList,
  reqZzwlList,
  reqKtlwList,
  reqSffyList,
  reqBsgyList,
} from '@/api'

const state = {
  bzdyList: [],
  qccyList: [],
  hzjyList: [],
  nyshList: [],
  zzwlList: [],
  ktlwList: [],
  sffyList: [],
  bsgyList: [],
}
const mutations = {
  forBzdyList(state, bzdyList) {
    state.bzdyList = bzdyList
  },
  forQccyList(state, qccyList) {
    state.qccyList = qccyList
  },
  forHzjyList(state, hzjyList) {
    state.hzjyList = hzjyList
  },
  forNyshList(state, nyshList) {
    state.nyshList = nyshList
  },
  forZzwlList(state, zzwlList) {
    state.zzwlList = zzwlList
  },
  forKtlwList(state, ktlwList) {
    state.ktlwList = ktlwList
  },
  forSffyList(state, sffyList) {
    state.sffyList = sffyList
  },
  forBsgyList(state, bsgyList) {
    state.bsgyList = bsgyList
  },
}
const actions = {
  async bzdyList({ commit }) {
    const result = await reqBzdyList()
    if (result.code === 200) {
      commit('forBzdyList', result.data)
    }
  },
  async qccyList({ commit }) {
    const result = await reqQccyList()
    if (result.code === 200) {
      commit('forQccyList', result.data)
    }
  },
  async hzjyList({ commit }) {
    const result = await reqHzjyList()
    if (result.code === 200) {
      commit('forHzjyList', result.data)
    }
  },
  async nyshList({ commit }) {
    const result = await reqNyshList()
    if (result.code === 200) {
      commit('forNyshList', result.data)
    }
  },
  async zzwlList({ commit }) {
    const result = await reqZzwlList()
    if (result.code === 200) {
      commit('forZzwlList', result.data)
    }
  },
  async ktlwList({ commit }) {
    const result = await reqKtlwList()
    if (result.code === 200) {
      commit('forKtlwList', result.data)
    }
  },
  async sffyList({ commit }) {
    const result = await reqSffyList()
    if (result.code === 200) {
      commit('forSffyList', result.data)
    }
  },
  async bsgyList({ commit }) {
    const result = await reqBsgyList()
    if (result.code === 200) {
      commit('forBsgyList', result.data)
    }
  },
}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters,
}
